import css from '@styled-system/css'
import { ComponentType, DetailedHTMLProps, ImgHTMLAttributes } from 'react'
import styled from 'styled-components'
import { compose, layout, LayoutProps } from 'styled-system'

type ImageProps = Omit<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>,
  keyof LayoutProps
> &
  LayoutProps

export const Image = styled.img<ImageProps>(
  css({
    display: 'inline-block',
    width: '100%',
  }),
  compose(layout),
) as ComponentType<ImageProps>
